interface BaseInputProps {
  val: string;
  inputLabel: string;
  inError: boolean;
  onTextChange(value: string): void;
  disabled?: boolean;
  maxLength?: number;
  inputPlaceholder?: string;
  extraClass?: string;
  extraClassTitle?: string;
  extraClassContainer?: string;
  dataCy?: string;
  type?: string;
  handleKeypress?(e: any): void;
}

const BaseInput: React.FC<BaseInputProps> = ({
  val,
  inputLabel,
  inError,
  onTextChange,
  disabled,
  inputPlaceholder,
  maxLength,
  extraClass,
  extraClassTitle,
  extraClassContainer,
  dataCy,
  type,
  handleKeypress,
}) => {
  return (
    <div className={`form-input-container ${extraClassContainer ?? ''}`}>
      <p className={`form-field-title nowrap-text ${extraClassTitle}`}>
        {inputLabel}
      </p>
      <input
        value={val}
        autoComplete="off"
        maxLength={maxLength}
        disabled={disabled}
        className={`form-text form-input ${
          inError ? 'error' : ''
        } ${extraClass}`}
        placeholder={inputPlaceholder ?? ''}
        onChange={(e) => {
          onTextChange(e.target.value.toString());
        }}
        data-cy={dataCy}
        type={type}
        onKeyDown={handleKeypress}
      />
    </div>
  );
};

export { BaseInput };
